/**
 * Constantes de Atividades Pedagógicas
 * Define o catálogo de atividades pedagógicas do EducaPaço
 * 
 * NOTA: Este arquivo substitui o antigo habilidades.js
 */

/**
 * IDs das atividades pedagógicas obrigatórias em núcleos pedagógicos
 */
export const ATIVIDADES_PEDAGOGICAS_OBRIGATORIAS = {
  PORTUGUES: "PORTUGUES",
  MATEMATICA: "MATEMATICA",
};

/**
 * Catálogo de atividades pedagógicas
 */
export const ATIVIDADES_PEDAGOGICAS = {
  PORTUGUES: {
    id: "PORTUGUES",
    nome: "Português",
    descricao: "Língua Portuguesa - Leitura, escrita e interpretação",
    obrigatoria: true,
    categoria: "Linguagens",
  },
  MATEMATICA: {
    id: "MATEMATICA",
    nome: "Matemática",
    descricao: "Matemática - Cálculos, raciocínio lógico e resolução de problemas",
    obrigatoria: true,
    categoria: "Exatas",
  },
  EDUCACAO_AMBIENTAL: {
    id: "EDUCACAO_AMBIENTAL",
    nome: "Educação Ambiental",
    descricao: "Conscientização ambiental e sustentabilidade",
    obrigatoria: false,
    categoria: "Ciências",
  },
  MUSICA: {
    id: "MUSICA",
    nome: "Música",
    descricao: "Artes musicais e expressão através da música",
    obrigatoria: false,
    categoria: "Artes",
  },
  ARTES_VISUAIS: {
    id: "ARTES_VISUAIS",
    nome: "Artes Visuais",
    descricao: "Desenho, pintura e expressão visual",
    obrigatoria: false,
    categoria: "Artes",
  },
  HISTORIA: {
    id: "HISTORIA",
    nome: "História",
    descricao: "Estudo histórico e contexto social",
    obrigatoria: false,
    categoria: "Humanas",
  },
  GEOGRAFIA: {
    id: "GEOGRAFIA",
    nome: "Geografia",
    descricao: "Espaço geográfico e relações humanas",
    obrigatoria: false,
    categoria: "Humanas",
  },
  CIENCIAS: {
    id: "CIENCIAS",
    nome: "Ciências",
    descricao: "Ciências naturais e experimentação",
    obrigatoria: false,
    categoria: "Ciências",
  },
  INFORMATICA: {
    id: "INFORMATICA",
    nome: "Informática",
    descricao: "Tecnologia da informação e computação",
    obrigatoria: false,
    categoria: "Tecnologia",
  },
};

/**
 * Lista de atividades pedagógicas para uso em selects
 */
export const ATIVIDADES_PEDAGOGICAS_LIST = Object.values(ATIVIDADES_PEDAGOGICAS).map(atividade => ({
  value: atividade.id,
  label: atividade.nome,
  description: atividade.descricao,
  obrigatoria: atividade.obrigatoria,
  categoria: atividade.categoria,
}));

/**
 * Lista de atividades pedagógicas obrigatórias
 */
export const ATIVIDADES_PEDAGOGICAS_OBRIGATORIAS_LIST = ATIVIDADES_PEDAGOGICAS_LIST.filter(a => a.obrigatoria);

/**
 * Lista de atividades pedagógicas opcionais
 */
export const ATIVIDADES_PEDAGOGICAS_OPCIONAIS_LIST = ATIVIDADES_PEDAGOGICAS_LIST.filter(a => !a.obrigatoria);

/**
 * Obtém uma atividade pedagógica por ID
 */
export const getAtividadePedagogicaById = id => {
  return ATIVIDADES_PEDAGOGICAS[id] || null;
};

/**
 * Verifica se uma atividade pedagógica é obrigatória
 */
export const isAtividadePedagogicaObrigatoria = id => {
  return id === ATIVIDADES_PEDAGOGICAS_OBRIGATORIAS.PORTUGUES || id === ATIVIDADES_PEDAGOGICAS_OBRIGATORIAS.MATEMATICA;
};

/**
 * Valida se as atividades pedagógicas obrigatórias estão presentes
 */
export const validarAtividadesPedagogicasObrigatorias = atividadesSelecionadas => {
  const ids = atividadesSelecionadas.map(a => (typeof a === "string" ? a : a.id || a.value));

  const temPortugues = ids.includes(ATIVIDADES_PEDAGOGICAS_OBRIGATORIAS.PORTUGUES);
  const temMatematica = ids.includes(ATIVIDADES_PEDAGOGICAS_OBRIGATORIAS.MATEMATICA);

  return {
    valido: temPortugues && temMatematica,
    faltaPortugues: !temPortugues,
    faltaMatematica: !temMatematica,
  };
};

// Aliases para compatibilidade com código legado
export const HABILIDADES = ATIVIDADES_PEDAGOGICAS;
export const HABILIDADES_LIST = ATIVIDADES_PEDAGOGICAS_LIST;
export const HABILIDADES_OBRIGATORIAS = ATIVIDADES_PEDAGOGICAS_OBRIGATORIAS;
export const HABILIDADES_OBRIGATORIAS_LIST = ATIVIDADES_PEDAGOGICAS_OBRIGATORIAS_LIST;
export const HABILIDADES_OPCIONAIS_LIST = ATIVIDADES_PEDAGOGICAS_OPCIONAIS_LIST;
export const getHabilidadeById = getAtividadePedagogicaById;
export const isHabilidadeObrigatoria = isAtividadePedagogicaObrigatoria;
export const validarHabilidadesObrigatorias = validarAtividadesPedagogicasObrigatorias;


















